import { useMemo, useState } from 'react'
import { IsListNotEmpty, ValueReferances } from '../utils'
import useFormData from './useFormData'

const useForm = () => {

    const [formValues, setFormValue] = useState({})
    const { getFormData } = useFormData()

    const GetValueFromField = (value) => {
        if (Array.isArray(value)) return returnArrVauesFromList(value)
        if (typeof value === 'object') return GetValueFromLookup(value)
        return value
    }

    const returnArrVauesFromList = (list) => {
        return list.map(item => GetValueFromLookup(item))
    }

    const GetValueFromLookup = (dataObject) => {
        var isLookup = Object.keys(dataObject).includes('value') || Object.keys(dataObject).includes('label')
        if (typeof dataObject === 'object' && isLookup) return dataObject?.value
    }

    const formDataResult = useMemo(() => {

        let finalFormValue = {}
        Object.entries(formValues).forEach(([key, val], index) => {
            finalFormValue[key] = GetValueFromField(val?.value)

        })

        return finalFormValue

    }, [formValues])

    const onSubmit = (formAction) => {
        if (validation()) return
        formAction(formDataResult)
    }

    const onSubmitFormData = (formAction) => {
        console.log(formDataResult)
        if (validation()) return
        const formData = getFormData(formDataResult)
        formAction(formData)
    }

    const validation = () => {
        const containError = Object.entries(formValues)
            .filter(([key, itemValue], index) => (!itemValue?.value && itemValue?.isRequired))
            .map(([key, itemValue], index) => ({ key: { ...itemValue, isError: true }, id_Key: key }))

        const newFormObject = { ...formValues }

        const isListNotValid = IsListNotEmpty(containError)

        containError.forEach((item, index) => {
            newFormObject[item?.id_Key] = item.key
        })
        setFormValue(newFormObject)
        return isListNotValid
    }

    const handleFormValues = (key, val) => {
        setFormValue(prev => ({ ...prev, [key]: val }))
    }

    const onReset = () => {
        let ObjectClearer = ValueReferances(formValues)?.cleared
        setFormValue(prev => ({ ...ObjectClearer }))
    }

    return {
        onSubmit,
        onReset,
        onSubmitFormData,
        formHandler: { formValues, handleFormValues },  // mustly passed to fields wrapper to for res params and inner destructure
        formDataResult
    }
}

export default useForm